import { withNavigationWatcher } from "./context/navigation";
import PackagingReport from "./pages/PackagingReport";
import CashInCashOut from "./pages/CashInCashOut";
import DistributionReport from "./pages/DistributionReport";
import GSTReport from "./pages/GSTReport";
import OverviewReport from "./pages/OverviewReport";
import PNPReport from "./pages/PNPReport";
import TaxExempt from "./pages/TaxExempt";

const routes = [
  {
    path: "/sales-packaging-report",
    component: PackagingReport,
  },
  {
    path: "/cash-in-cash-out",
    component: CashInCashOut,
  },
  {
    path: "/central-distribution-report",
    component: DistributionReport,
  },

  {
    path: "/gst-payable-report",
    component: GSTReport,
  },

  {
    path: "/overview-short-report",
    component: OverviewReport,
  },
  {
    path: "/pnp-report",
    component: PNPReport,
  },
  {
    path: "/tax-exempt-report",
    component: TaxExempt,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
